export enum CarouselGroup {
  Watch = 'Watch',
  Jewelry = 'Jewelry',
}

export type CarouselSubSlide = {
  id?: number
  sku: string
  productId: number
  title: string
  subtitle?: string
  productImage: string
  displayOrder: number
  slug?: string
}

export type CarouselMainSlideResponse = {
  id: number
  group: CarouselGroup
  entityId: number
  title: string
  subtitle?: string
  mainImage: string
  displayOrder: number
  subSlides: CarouselSubSlide[]
}

export type CarouselMainSlide = CarouselMainSlideResponse & {
  key: string
}

export type CarouselMainSlideCreateInput = {
  group: CarouselGroup
  entityId: number
  title: string
  subtitle?: string
  mainImage: string
  subSlides: Omit<CarouselSubSlide, 'slug'>[]
}

export type CarouselMainSlideUpdateInput = {
  id: number
  entityId: number
  title: string
  subtitle?: string
  mainImage: string
  subSlides: Omit<CarouselSubSlide, 'slug'>[]
}

export type CarouselReorderInput = {
  id: number
  displayOrder: number
}
